// extracted by mini-css-extract-plugin
export default {"peopleGrid":"People-module__peopleGrid__TGc3xbU"};